// src/reducers/userReducer.js
import {
    GET_MENU_IMAGE_SUCCESS,
    GET_MENU_IMAGE_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const menuImageReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_MENU_IMAGE_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_MENU_IMAGE_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  